import React from "react";
import { Route, Routes } from "react-router-dom";
import { notification } from "antd";
import { useClient } from "../Context/ClientContext";
import { NotificationPlacement } from "antd/es/notification/interface";
import AddDeliveryChallan from "../Pages/Sales/AddDeliveryChallan";
import AddSalesInvoice from "../Pages/Sales/AddSalesInvoice";
import DashboardTemplate from "../Template/DashboardTemplate";
import SalesNestedRoute from "../Pages/Sales/SalesNestedRoute";
import SalesInvoiceTemplate from "../Template/SalesInvoiceTemplate";
import ExpensesIncomeNestedRoute from "../Pages/Expenses&income/ExpensesIncomeNestedRoute";
import AddSalesCreditNotesNew from "../Pages/Sales/AddSalesCreditNotesNew";
import PurchaseNestedRoute from "../Pages/Purchase/PurchaseNestedRoute";
import AssetsNestedRoute from "../Pages/Assets/AssetsNestedRoute";
import AddExpensesInvoice from "../Pages/Expenses&income/AddExpensesIncome";
import ShareCapitalNestedRoute from "../Pages/Share Capital/ShareCapitalNestedRoute";
import TrialBalance from "../Pages/Reports/TrialBalance";
import Journals from "../Pages/Journals/JournalsTable";
import AddSalesCreditNote from "../Pages/Sales/AddSalesCreditNotesNew";
import InventoryTabs from "../Pages/ItemInventory/InventoryTabs";
import BankingNestedRoute from "../Pages/Banking/BankingNestedRoute";
import AddPaymentInNew from "../Pages/Sales/AddPaymentInNew";
import TrialBalanceNew from "../Pages/Reports/TrialBalanceNew";
import MasterNestedRoute from "../Pages/Master/MasterNestedRoute";
//import LedgerNew from "../Pages/Reports/LedgerNew";
import LedgerDetails from "../Pages/Master/Ledger/LedgerDetails";
import { Registers } from "../Pages/Reports/Register";
import GroupDetails from "../Pages/Master/Group/AllDetailsGroupWise/GroupDetails";
import AddOrder from "../Pages/Sales/AddOrder";
import ProfitAndLossNew from "../Pages/Reports/ProfitAndLossNew";
import { AgeingReportTypes, Statements } from "../Services/ReportsServiceNew";
import AddJournalNew from "../Pages/Journals/AddJornalNew";
import SettingNestedRoute from "../Pages/Settings/SettingNestedRoute";
import GeneralLedger from "../Pages/Reports/GeneralLedger";
// import EditInvoiceTemplate from "./EditInvoiceTemplate";
import EditInvoiceTemplate from "../Pages/Settings/EditInvoiceTemplate";
import Reports from "../Pages/Reports/Reports";
import Ageing from "../Pages/Reports/Ageing";
import PartyOutstanding from "../Pages/Reports/PartyOutstanding";
import FAR from "../Pages/Reports/FAR";
import BRSReport from "../Pages/Reports/BRSReport";
import BankTransactionsTab from "../Pages/Banking/Banks/BankTransactionsTab";
import AssetModel from "../Pages/Assets/AssetModel";
import DraftTable from "../Pages/Draft/DraftTable";
import { SearchLedgerByGroupsTypes } from "../Services/LedgerService";
import PartyNestedRoute from "../Pages/Master/PartyNestedRoute";
import ItemNestedRoute from "../Pages/Purchase/ItemNestedRoute";
import GSTReports from "../Pages/Reports/GSTReports/GSTReports";
import NewDashboard from "../Pages/MainDashboard/NewDashboard";
import ResourceNotFound from "./ResourceNotFound";
import { useUser } from "../../Context/UserContext";
import { IAccessSettings } from "../../Types";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Pages/Users/UserSecurityFind";
import RoleTable from "../Pages/Users/RolesTable";
import { SettingsSections } from "../Services/SettingService";
import { IPermissionActionType } from "../Pages/Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../Context/RoleContext";
import Organisations from "../Pages/Organisations/Organisations";
import OrganisationNestedRoute from "../Pages/Organisations/OrganisationNestedRoute";
// import BankTransactionsTab from "../Pages/Banking/Banks/BankTransactionsTab";

// ---------- React.lazy ----------

// const AsyncSalesInvoiceTemplate = React.lazy(
//   () => import("../Template/SalesInvoiceTemplate")
// );
// const AsyncDashboardTemplate = React.lazy(
//   () => import("../Template/DashboardTemplate")
// );
// const AsyncAddSalesCreditNotes = React.lazy(
//   () => import("../Pages/Sales/AddSalesCreditNotesNew")
// );
// const AsyncSalesOrders = React.lazy(
//   () => import("../Pages/Sales/AddSalesOrder")
// );
// const AsyncAddSalesInvoice = React.lazy(
//   () => import("../Pages/Sales/AddSalesInvoice")
// );
// const AsyncAddQuotation = React.lazy(
//   () => import("../Pages/Sales/AddQuotation")
// );
// const AsyncSalesNestedRoute = React.lazy(
//   () => import("../Pages/Sales/SalesNestedRoute")
// );
// const AsyncAddPaymentIn = React.lazy(
//   () => import("../Pages/Sales/AddPaymentIn")
// );
// const AsyncShareCapitalNestedRoute = React.lazy(
//   () => import("../Pages/Share Capital/ShareCapitalNestedRoute")
// );
// const AsyncJournals = React.lazy(
//   () => import("../Pages/Journals/JournalsTable")
// );
// const AsyncAddJournal = React.lazy(
//   () => import("../Pages/Journals/AddJournal")
// );
// const AsyncAssetsNestedRoute = React.lazy(
//   () => import("../Pages/Assets/AssetsNestedRoute")
// );
// const AsyncPurchaseNestedRoute = React.lazy(
//   () => import("../Pages/Purchase/PurchaseNestedRoute")
// );
// const AsyncAddPurchaseInvoice = React.lazy(
//   () => import("../Pages/Purchase/AddPurchaseInvoice")
// );
// const AsyncAddPurchaseCreditNote = React.lazy(
//   () => import("../Pages/Purchase/AddPurchaseCreditNote")
// );
// const AsyncAddPurchaseOrder = React.lazy(
//   () => import("../Pages/Purchase/AddPurchaseOrder")
// );
// // const AsyncAddPurchasePayment = React.lazy(
// //   () => import("../Pages/Purchase/AddPurchasePayment")
// // );
// const AsyncAddPayment = React.lazy(
//   () => import("../Pages/Purchase/AddPaymentOut")
// );
// const AsyncLedger = React.lazy(() => import("../Pages/Ledger/Ledger"));
// const AsyncTrialBalance = React.lazy(
//   () => import("../Pages/TrialBalance/TrialBalance")
// );
// const AsyncSettings = React.lazy(() => import("../Pages/Settings/Settings"));
// const AsyncChartOfAccounts = React.lazy(
//   () => import("../Pages/ChartOfAccounts/ChartOfAccounts")
// );
// const AsyncAgeing = React.lazy(() => import("../Pages/Ageing/Ageing"));
// const AsyncBalanceSheet = React.lazy(
//   () => import("../Pages/BalanceSheet/BalanceSheet")
// );
// const AsyncProfitAndLoss = React.lazy(
//   () => import("../Pages/ProfitAndLoss/ProfitAndLoss")
// );
// const AsyncParties = React.lazy(() => import("../Pages/Parties/Party"));

// // const AsyncIncomeIncome = React.lazy(
// //   () => import("../Pages/Expenses&income/ExpensesIncomeNestedRoute")
// // );
// const AsyncExpensesIncomeNestedRoute = React.lazy(
//   () => import("../Pages/Expenses&income/ExpensesIncomeNestedRoute")
// );
// const AsyncAddExpensesInvoice = React.lazy(
//   () => import("../Pages/Expenses&income/AddExpenses")
// );
// const AsyncAddIncomeInvoice = React.lazy(
//   () => import("../Pages/Expenses&income/AddIncome")
// );
// const AsyncAddCategory = React.lazy(
//   () => import("../Pages/Expenses&income/AddCategoryModel")
// );

// const AsyncBankRules = React.lazy(() => import("../Pages/BackRules/BankRules"));
// const AsyncGstReturn = React.lazy(() => import("../Pages/GstReturn/GstReturn"));
// const AsyncOpeningBalance = React.lazy(
//   () => import("../Pages/OpeningBalance/OpeningBalance")
// );

// // const AsyncMainDashboard = React.lazy(
// //   () => import("../Pages/MainDashboard/MainDashboard")
// // );

export type NotificationType = "success" | "info" | "warning" | "error";

export enum ISilderName {
  Dashboard,
  Party,
  Item,
  Sales,
  Purchase,
  Expenses,
  Journals,
  Banking,
  FixedAsset,
  Draft,
  Registers,
  Master,
  Settings,
  ShareCapital,
  Organisations,
}

export const notificationContext = React.createContext<any>({});
const PageRoute = () => {
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  // const useAccessSettingsData: IAccessSettings = accessSettings();
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (
    type: NotificationType,
    message: string,
    description?: string,
    duration?: number,
    closeIcon?: boolean,
    placement?: NotificationPlacement,
    icon?: any
  ) => {
    api[type]({
      message: message,
      description: description,
      duration: duration ? duration : 4,
      // closeIcon: closeIcon ? false : <CloseOutlined  />,
      // style: {
      //   marginTop: "23px",
      //   padding: "15px 12px 7px 15px",
      // },
      placement: placement,
      icon: icon,
    });
  };

  return (
    <notificationContext.Provider value={{ openNotification }}>
      <>
        {/* <React.Suspense fallback={<FullPageSpinner />}> */}
        <Routes>
          {/* Page not found */}
          {/*  ----- Dashboard Route -----*/}
          <Route
            path={`${currentClient?.id}/dashboard`}
            element={
              <DashboardTemplate
                element={
                  findUserOnlyOnePremission(
                    "Dashboard.View",
                    clientSpecificRole(),
                    currentClient?.id!
                  ) ? (
                    <NewDashboard />
                  ) : (
                    <ResourceNotFound pageHeight="100%" />
                  )
                }
                breadcrumprops={[
                  {
                    item: "NewDashBoard",
                  },
                ]}
              />
            }
          />
          {/*  ----- Parties Route -----*/}
          <Route
            key="party"
            path={`/${currentClient?.id}/party/*`}
            // path={"sales/*"}
            element={
              // <AsyncSalesInvoiceTemplate
              findUserPremission(
                ["Master.Ledger.Party.View", "Master.Group.Party.View"],
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <SalesInvoiceTemplate
                  // element={<AsyncSalesNestedRoute />}
                  element={<PartyNestedRoute />}
                  silderName={ISilderName.Party}
                  breadcrumprops={[
                    {
                      item: "Party",
                      path: `/billing/clients/${currentClient?.id}/party/Parties`,
                    },
                  ]}
                  menuprops={[
                    {
                      showData: "Parties",
                    },
                    {
                      showData: "Parties Group",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/*  ----- Item Route -----*/}
          <Route
            key="item"
            path={`/${currentClient?.id}/item/*`}
            // path={"sales/*"}
            element={
              // <AsyncSalesInvoiceTemplate
              findUserPremission(
                [
                  "Master.Item.View",
                  "Master.Item.Category.View",
                  "Master.Item.Unit.View",
                  "Master.Item.Locations.View",
                ],
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <SalesInvoiceTemplate
                  // element={<AsyncSalesNestedRoute />}
                  element={<ItemNestedRoute />}
                  silderName={ISilderName.Item}
                  breadcrumprops={[
                    {
                      item: "Item",
                      path: `/billing/clients/${currentClient?.id}/item/items`,
                    },
                  ]}
                  menuprops={[
                    {
                      showData: "Items",
                    },
                    {
                      showData: "Item Category",
                    },
                    {
                      showData: "Units",
                    },
                    {
                      showData: "Item Locations",
                      // path: `/billing/clients/${currentClient?.id}/master/itemlocations`,
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Party Details Sales Route ----------- */}
          <Route
            path={`${currentClient?.id}/sales/addInvoice/:partyId`}
            element={
              findUserPremission(
                [
                  "Voucher.Sales.Invoice.Edit",
                  // "Voucher.Sales.ProformaInvoice.Edit",
                  // "Voucher.Sales.CreditNote.Edit",
                  // "Voucher.Sales.Receipt.Edit",
                  // "Voucher.Sales.Estimate.Edit",
                  // "Voucher.Sales.SalesOrder.Edit",
                  // "Master.Ledger.Customer.Edit",
                ],
                clientSpecificRole(),
                currentClient?.id!,
                [SettingsSections.Invoice],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Parties",
                      path: `/billing/clients/${currentClient?.id}/parties`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/addCreditNote/:partyId`}
            element={
              findUserPremission(
                ["Voucher.Sales.CreditNote.Edit"],
                clientSpecificRole(),
                currentClient?.id!,
                [SettingsSections.CrNote],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesCreditNote />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "CreditNote",
                      path: `/billing/clients/${currentClient?.id}/sales/creditNotes`,
                    },
                    {
                      item: "Parties",
                      path: `/billing/clients/${currentClient?.id}/parties`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* <Route
            path={`${currentClient?.id}/sales/receipt/:partyId`}
            element={
              <DashboardTemplate
                element={<AddPaymentInNew />}
                breadcrumprops={[
                  {
                    item: "Sales",
                    path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                  },
                  {
                    item: "Receipts",
                    path: `/billing/clients/${currentClient?.id}/sales/receipts`,
                  },
                  {
                    item: "Parties",
                    path: `/billing/clients/${currentClient?.id}/parties`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          /> */}
          {/* <Route
            path={`${currentClient?.id}/sales/addEstimate/:partyId`}
            element={
              <DashboardTemplate
                element={<AddOrder />}
                breadcrumprops={[
                  {
                    item: "Sales",
                    path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                  },
                  {
                    item: "Estimate",
                    path: `/billing/clients/${currentClient?.id}/sales/estimate`,
                  },
                  {
                    item: "Parties",
                    path: `/billing/clients/${currentClient?.id}/parties`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          /> */}
          {/* <Route
            path={`${currentClient?.id}/sales/addOrder/:partyId`}
            element={
              <DashboardTemplate
                element={<AddOrder />}
                breadcrumprops={[
                  {
                    item: "Sales",
                    path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                  },
                  {
                    item: "Order",
                    path: `/billing/clients/${currentClient?.id}/sales/order`,
                  },
                  {
                    item: "Parties",
                    path: `/billing/clients/${currentClient?.id}/parties`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          /> */}
          {/* <Route
            path={`${currentClient?.id}/sales/addDeliveryChallan/:partyId`}
            element={
              <DashboardTemplate
                element={<AddDeliveryChallan />}
                breadcrumprops={[
                  {
                    item: "Sales",
                    path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                  },
                  {
                    item: "DeliveryChallan",
                    path: `/billing/clients/${currentClient?.id}/sales/addDeliveryChallan`,
                  },
                  {
                    item: "Parties",
                    path: `/billing/clients/${currentClient?.id}/parties`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          /> */}
          {/* ----------- Party Details Purchase Route ----------- */}
          {/* <Route
            path={`${currentClient?.id}/purchase/purchaseBill/:partyId`}
            element={
              findUserPremission(
                ["Voucher.Sales.CreditNote.Edit"],
                
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Invoice",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Parties",
                      path: `/billing/clients/${currentClient?.id}/parties`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/addDebitNote/:partyId`}
            element={
              <DashboardTemplate
                element={<AddSalesCreditNotesNew />}
                breadcrumprops={[
                  {
                    item: "Purchase",
                    path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                  },
                  {
                    item: "DebitNote",
                    path: `/billing/clients/${currentClient?.id}/purchase/debitNote`,
                  },
                  {
                    item: "Parties",
                    path: `/billing/clients/${currentClient?.id}/parties`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/addPaymentOut/:partyId`}
            element={
              <DashboardTemplate
                element={<AddPaymentOut />}
                breadcrumprops={[
                  {
                    item: "Purchase",
                    path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                  },
                  {
                    item: "Payment",
                    path: `/billing/clients/${currentClient?.id}/purchase/paymentOut`,
                  },
                  {
                    item: "Parties",
                    path: `/billing/clients/${currentClient?.id}/parties`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/addPaymentOut/:partyId`}
            element={
              <DashboardTemplate
                element={<AddPaymentOut />}
                breadcrumprops={[
                  {
                    item: "Purchase",
                    path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                  },
                  {
                    item: "PaymentOut",
                    path: `/billing/clients/${currentClient?.id}/purchase/purchaseOut`,
                  },
                  {
                    item: "Parties",
                    path: `/billing/clients/${currentClient?.id}/parties`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/addOrder/:partyId`}
            element={
              <DashboardTemplate
                element={<AddOrder />}
                breadcrumprops={[
                  {
                    item: "Purchase",
                    path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                  },
                  {
                    item: "Order",
                    path: `/billing/clients/${currentClient?.id}/purchase/order`,
                  },
                  {
                    item: "Parties",
                    path: `/billing/clients/${currentClient?.id}/parties`,
                  },
                  {
                    item: "Add",
                  },
                ]}
              />
            }
          /> */}
          {/* Master Routes */}
          <Route
            key="salesInvoice"
            path={`/${currentClient?.id}/master/*`}
            // path={"sales/*"}
            element={
              findUserPremission(
                ["Master.Ledger.View", "Master.Group.View"],
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <SalesInvoiceTemplate
                  element={<MasterNestedRoute />}
                  silderName={ISilderName.Master}
                  breadcrumprops={[
                    {
                      item: "Master",
                      path: `/billing/clients/${currentClient?.id}/master/group`,
                    },
                  ]}
                  menuprops={[
                    {
                      showData: "Ledger",
                      addButton: "addLedger",
                    },
                    {
                      showData: "Group",
                      addButton: "addGroup",
                    },
                    {
                      showData: "Departments",
                      addButton: "addDepartment",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* Master Inside Details Routes */}
          <Route
            path={`/${currentClient?.id}/master/ledger/:ledgerId`}
            element={
              <DashboardTemplate
                element={
                  <LedgerDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.BillingAllGroups
                    }
                    showName="Ledger"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Master",
                    path: `/billing/clients/${currentClient?.id}/master/ledger`,
                  },
                  {
                    item: "Ledger",
                    path: `/billing/clients/${currentClient?.id}/master/ledger`,
                  },
                  {
                    item: "Details",
                  },
                ]}
              />
            }
          />
          <Route
            path={`/${currentClient?.id}/master/group/:groupId`}
            element={
              <DashboardTemplate
                element={
                  <GroupDetails
                    searchLedgerByGroupsTypes={SearchLedgerByGroupsTypes.All}
                  />
                }
                breadcrumprops={[
                  {
                    item: "Master",
                    path: `/billing/clients/${currentClient?.id}/master/ledger`,
                  },
                  {
                    item: "Group",
                    path: `/billing/clients/${currentClient?.id}/master/group`,
                  },
                  {
                    item: "Details",
                  },
                ]}
              />
            }
          />
          {/* Party Inside Details Routes */}
          <Route
            path={`/${currentClient?.id}/party/partyLedger/:ledgerId`}
            element={
              <DashboardTemplate
                element={
                  <LedgerDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.PartiesOnly
                    }
                    showName="Party Name"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Party",
                    path: `/billing/clients/${currentClient?.id}/party/parties`,
                  },
                  {
                    item: "PartyLedger",
                  },
                ]}
              />
            }
          />
          <Route
            path={`/${currentClient?.id}/party/partiesGroup/:groupId`}
            element={
              <DashboardTemplate
                element={
                  <GroupDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.PartiesOnly
                    }
                    showName="Party"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Party Group",
                    path: `/billing/clients/${currentClient?.id}/party/partiesGroup`,
                  },
                  {
                    item: "Details",
                  },
                ]}
              />
            }
          />
          {/* Expenses Inside Details Routes */}
          <Route
            path={`/${currentClient?.id}/expensesLedger/:ledgerId`}
            element={
              <DashboardTemplate
                element={
                  <LedgerDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.AllExpenses
                    }
                    showName="Expense"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Expenses",
                    path: `/billing/clients/${currentClient?.id}/expensesLedger`,
                  },
                  {
                    item: "ExpensesLedger",
                  },
                ]}
              />
            }
          />
          <Route
            path={`/${currentClient?.id}/expensesGroup/:groupId`}
            element={
              <DashboardTemplate
                element={
                  <GroupDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.AllExpenses
                    }
                    showName="Expense"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Expenses Group",
                    path: `/billing/clients/${currentClient?.id}/expensesGroup`,
                  },
                  {
                    item: "Group Details",
                  },
                ]}
              />
            }
          />
          {/* Income Inside Details Routes */}
          <Route
            path={`/${currentClient?.id}/incomeLedger/:ledgerId`}
            element={
              <DashboardTemplate
                element={
                  <LedgerDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.IndirectIncomeOnly
                    }
                    showName="Income"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Income",
                    path: `/billing/clients/${currentClient?.id}/income`,
                  },
                  {
                    item: "IncomeLedger",
                  },
                ]}
              />
            }
          />
          <Route
            path={`/${currentClient?.id}/incomeGroup/:groupId`}
            element={
              <DashboardTemplate
                element={
                  <GroupDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.IndirectIncomeOnly
                    }
                    showName="Income"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Income Group",
                    path: `/billing/clients/${currentClient?.id}/incomeGroup`,
                  },
                  {
                    item: "Group Details",
                  },
                ]}
              />
            }
          />
          {/* Customer Inside Details Routes */}
          <Route
            path={`/${currentClient?.id}/sales/customerLedger/:ledgerId`}
            element={
              <DashboardTemplate
                element={
                  <LedgerDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.DebtorsOnly
                    }
                    showName="Customer"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Sales",
                    path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                  },
                  {
                    item: "Customers",
                    path: `/billing/clients/${currentClient?.id}/sales/customers`,
                  },
                  {
                    item: "Ledger",
                  },
                ]}
              />
            }
          />
          <Route
            path={`/${currentClient?.id}/sales/customerGroup/:groupId`}
            element={
              <DashboardTemplate
                element={
                  <GroupDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.DebtorsOnly
                    }
                    showName="Income"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Sales",
                    path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                  },
                  {
                    item: "Customers",
                    path: `/billing/clients/${currentClient?.id}/sales/customers`,
                  },
                  {
                    item: "Group",
                  },
                ]}
              />
            }
          />
          {/* Supplier Inside Details Routes */}
          <Route
            path={`/${currentClient?.id}/purchase/supplierLedger/:ledgerId`}
            element={
              <DashboardTemplate
                element={
                  <LedgerDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.CreditorsOnly
                    }
                    showName="Supplier"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Purchase",
                    path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                  },
                  {
                    item: "Suppliers",
                    path: `/billing/clients/${currentClient?.id}/purchase/suppliers`,
                  },
                  {
                    item: "Ledger",
                  },
                ]}
              />
            }
          />
          <Route
            path={`/${currentClient?.id}/purchase/supplierGroup/:groupId`}
            element={
              <DashboardTemplate
                element={
                  <GroupDetails
                    searchLedgerByGroupsTypes={
                      SearchLedgerByGroupsTypes.CreditorsOnly
                    }
                    showName="Income"
                  />
                }
                breadcrumprops={[
                  {
                    item: "Purchase",
                    path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                  },
                  {
                    item: "Suppliers",
                    path: `/billing/clients/${currentClient?.id}/purchase/suppliers`,
                  },
                  {
                    item: "Group",
                  },
                ]}
              />
            }
          />
          {/*----------- Sales Route -----------*/}
          <Route
            key="salesInvoice"
            path={`/${currentClient?.id}/sales/*`}
            // path={"sales/*"}
            element={
              findUserPremission(
                [
                  "Voucher.Sales.Invoice.View",
                  "Voucher.Sales.ProformaInvoice.View",
                  "Voucher.Sales.CreditNote.View",
                  "Voucher.Sales.Receipt.View",
                  "Voucher.Sales.Estimate.View",
                  "Voucher.Sales.SalesOrder.View",
                  "Master.Ledger.Customer.View",
                ],
                clientSpecificRole(),
                currentClient?.id,
                [
                  SettingsSections.Invoice,
                  SettingsSections.PInvoice,
                  SettingsSections.CrNote,
                  SettingsSections.Receipt,
                  SettingsSections.Quotation,
                  SettingsSections.SOrder,
                ],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                // <AsyncSalesInvoiceTemplate
                <SalesInvoiceTemplate
                  // element={<AsyncSalesNestedRoute />}
                  element={<SalesNestedRoute />}
                  silderName={ISilderName.Sales}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                  ]}
                  menuprops={[
                    {
                      showData: "Invoices",
                      addButton: "addInvoice",
                    },
                    {
                      showData: "Proforma Invoices",
                      addButton: "addProformaInvoices",
                    },
                    {
                      showData: "Credit Notes",
                      addButton: "addCreditNote",
                    },
                    {
                      showData: "Receipts",
                      addButton: "addPaymentIn",
                    },
                    {
                      showData: "Estimate",
                      addButton: "addEstimate",
                    },
                    {
                      showData: "Sales Order",
                      addButton: "addOrder",
                    },
                    {
                      showData: "Customers",
                      addButton: "customers",
                    },
                    // {
                    //   showData: "Delivery Challan",
                    //   addButton: "addDeliveryChallan",
                    // },
                    // {
                    //   showData: "Items",
                    //   addButton: "salesItem",
                    // },
                    // {
                    //   showData: "Customers",
                    // },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/addInvoice`}
            element={
              findUserPremission(
                ["Voucher.Sales.Invoice.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Invoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/addProformaInvoice`}
            element={
              findUserPremission(
                ["Voucher.Sales.ProformaInvoice.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.PInvoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Proforma Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/proformaInvoice`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* Add sales invoice to sales order  */}
          <Route
            path={`${currentClient?.id}/sales/addInvoice/order/:salesOrderId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Invoice.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Invoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "SalesOrder",
                      path: `/billing/clients/${currentClient?.id}/sales/order`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* Add sales invoice to estimate  */}
          <Route
            path={`${currentClient?.id}/sales/addInvoice/estimate/:quotationId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Invoice.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Invoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Estimate",
                      path: `/billing/clients/${currentClient?.id}/sales/estimate`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* Add sales invoice to proforma invoice  */}
          <Route
            path={`${currentClient?.id}/sales/addInvoice/proformaInvoice/:proformaInvoiceId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Invoice.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Invoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "ProformaInvoice",
                      path: `/billing/clients/${currentClient?.id}/sales/proformaInvoices`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* Add Estimate to sales order  sales/addSalesOrder/estimate */}
          <Route
            path={`${currentClient?.id}/sales/addSalesOrder/estimate/:estimateId`}
            element={
              findUserPremission(
                ["Voucher.Sales.SalesOrder.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.SOrder],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Order",
                      path: `/billing/clients/${currentClient?.id}/sales/order`,
                    },
                    {
                      item: "Estimate",
                      path: `/billing/clients/${currentClient?.id}/sales/estimate`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editInvoice/:updateId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Invoice.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Invoice],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editProformaInvoice/:proformaId`}
            element={
              findUserPremission(
                ["Voucher.Sales.ProformaInvoice.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.PInvoice],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Proforma Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/proformaInvoices`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editInvoiceDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Invoice.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Invoice],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* -----------------------Order Draft------------------------ */}
          <Route
            path={`${currentClient?.id}/sales/editSalesOrderDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Sales.SalesOrder.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.SOrder],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "SalesOrder",
                      path: `/billing/clients/${currentClient?.id}/sales/order`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/editPurchaseOrderDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.PurchaseOrder.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.POrder],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "PurchaseOrder",
                      path: `/billing/clients/${currentClient?.id}/purchase/order`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />

          {/* -----------------------Quotations Draft------------------------ */}
          <Route
            path={`${currentClient?.id}/sales/editEstimateDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Estimate.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Quotation],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Estimate",
                      path: `/billing/clients/${currentClient?.id}/sales/estimate`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editCreditNoteDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Sales.CreditNote.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.CrNote],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesCreditNotesNew />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "CreditNotes",
                      path: `/billing/clients/${currentClient?.id}/sales/creditNotes`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/editDebitNoteDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.DebitNote.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.DrNote],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesCreditNotesNew />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "DebitNote",
                      path: `/billing/clients/${currentClient?.id}/purchase/debitNote`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editReceiptDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Receipt.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Receipt],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddPaymentInNew />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Receipt",
                      path: `/billing/clients/${currentClient?.id}/sales/receipts`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/editPaymentOutDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.PaymentOut.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.POrder],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddPaymentInNew />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "PaymentOut",
                      path: `/billing/clients/${currentClient?.id}/purchase/paymentOut`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/cloneInvoice/:cloneId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Invoice.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Invoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Invoices",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Clone",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/addCreditNote`}
            element={
              findUserPremission(
                ["Voucher.Sales.CreditNote.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.CrNote],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesCreditNotesNew />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "CreditNotes",
                      path: `/billing/clients/${currentClient?.id}/sales/creditNotes`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editCreditNote/:creditNoteId`}
            element={
              findUserPremission(
                ["Voucher.Sales.CreditNote.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.CrNote],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesCreditNotesNew />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "CreditNotes",
                      path: `/billing/clients/${currentClient?.id}/sales/creditNotes`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/addReceipt`}
            element={
              findUserPremission(
                ["Voucher.Sales.Receipt.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Receipt],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddPaymentInNew />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Receipts",
                      path: `/billing/clients/${currentClient?.id}/sales/receipts`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editReceipt/:paymentId`}
            element={
              findUserPremission(
                ["Voucher.Sales.Receipt.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Receipt],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddPaymentInNew />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Receipts",
                      path: `/billing/clients/${currentClient?.id}/sales/receipts`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/addEstimate`}
            element={
              findUserPremission(
                ["Voucher.Sales.Estimate.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Quotation],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Estimate",
                      path: `/billing/clients/${currentClient?.id}/sales/estimate`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/editPurchaseOrder/:id`}
            element={
              findUserPremission(
                ["Voucher.Purchase.PaymentOut.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Payment],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "PurchaseOrder",
                      path: `/billing/clients/${currentClient?.id}/purchase/order`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editEstimate/:id`}
            element={
              findUserPremission(
                ["Voucher.Sales.Estimate.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Quotation],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Estimate",
                      path: `/billing/clients/${currentClient?.id}/sales/estimate`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/addOrder`}
            element={
              findUserPremission(
                ["Voucher.Sales.SalesOrder.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.SOrder],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Order",
                      path: `/billing/clients/${currentClient?.id}/sales/order`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/addDeliveryChallan`}
            element={
              findUserPremission(
                ["Voucher.Sales.DeliveryChallan.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.DChallan],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddDeliveryChallan />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "Delivery Challan",
                      path: `/billing/clients/${currentClient?.id}/sales/deliveryChallan`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editSalesOrder/:id`}
            element={
              findUserPremission(
                ["Voucher.Sales.SalesOrder.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.SOrder],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "SalesOrder",
                      path: `/billing/clients/${currentClient?.id}/sales/order`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/sales/editDeliveryChallan/:id`}
            element={
              findUserPremission(
                ["Voucher.Sales.DeliveryChallan.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.DChallan],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddDeliveryChallan />}
                  breadcrumprops={[
                    {
                      item: "Sales",
                      path: `/billing/clients/${currentClient?.id}/sales/invoices`,
                    },
                    {
                      item: "DeliveryChallan",
                      path: `/billing/clients/${currentClient?.id}/sales/addDeliveryChallan`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Purchase Route ----------- */}
          <Route
            key="dashboard"
            path={`/${currentClient?.id}/purchase/*`}
            element={
              findUserPremission(
                [
                  "Voucher.Purchase.Bill.View",
                  "Voucher.Purchase.DebitNote.View",
                  "Voucher.Purchase.PaymentOut.View",
                  "Voucher.Purchase.PurchaseOrder.View",
                  "Master.Ledger.Suppliers.View",
                ],
                clientSpecificRole(),
                currentClient?.id,
                [
                  SettingsSections.PurInvoice,
                  SettingsSections.DrNote,
                  SettingsSections.Payment,
                  SettingsSections.POrder,
                ],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <SalesInvoiceTemplate
                  element={<PurchaseNestedRoute />}
                  silderName={ISilderName.Purchase}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                  ]}
                  menuprops={[
                    {
                      showData: "Purchase Bill",
                      addButton: "addInvoice",
                    },
                    {
                      showData: "Debit Note",
                      addButton: "addDebitNote",
                    },
                    {
                      showData: "Payment Out",
                      addButton: "addPaymentOut",
                    },
                    {
                      showData: "Purchase Order",
                      addButton: "addOrder",
                    },
                    {
                      showData: "Suppliers",
                      addButton: "suppliers",
                    },
                    // {
                    //   showData: "Items",
                    //   addButton: "purchaseItem",
                    // },
                    // {
                    //   showData: "Suppliers",
                    // },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/addPurchaseBill`}
            element={
              findUserPremission(
                ["Voucher.Purchase.Bill.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.PurInvoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Invoice",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/editPurchaseBill/:updateId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.Bill.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.PurInvoice],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "purchaseBill",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/editBillDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.Bill.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.PurInvoice],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "purchaseBill",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* Add Purchase order to Purchase invoice */}
          <Route
            path={`${currentClient?.id}/purchase/addPurchaseBill/order/:purchaseOrderId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.Bill.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.PurInvoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "PurchaseBill",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Order",
                      path: `/billing/clients/${currentClient?.id}/purchase/order`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/cloneBill/:cloneId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.Bill.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.PurInvoice],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "PurchaseBill",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Clone",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/addDebitNote`}
            element={
              findUserPremission(
                ["Voucher.Purchase.DebitNote.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.DrNote],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesCreditNotesNew />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Debit Note",
                      path: `/billing/clients/${currentClient?.id}/purchase/debitNote`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/editDebitNote/:creditNoteId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.DebitNote.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.DrNote],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddSalesCreditNotesNew />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Debit Note",
                      path: `/billing/clients/${currentClient?.id}/purchase/debitNote`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/addOrder`}
            element={
              findUserPremission(
                ["Voucher.Purchase.PurchaseOrder.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.POrder],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddOrder />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Order",
                      path: `/billing/clients/${currentClient?.id}/purchase/order`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/addPaymentOut`}
            element={
              findUserPremission(
                ["Voucher.Purchase.PaymentOut.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.POrder],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddPaymentInNew />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Payments",
                      path: `/billing/clients/${currentClient?.id}/purchase/paymentOut`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/purchase/editPaymentOut/:paymentId`}
            element={
              findUserPremission(
                ["Voucher.Purchase.PaymentOut.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Payment],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddPaymentInNew />}
                  breadcrumprops={[
                    {
                      item: "Purchase",
                      path: `/billing/clients/${currentClient?.id}/purchase/purchaseBill`,
                    },
                    {
                      item: "Payments",
                      path: `/billing/clients/${currentClient?.id}/purchase/paymentOut`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Assets Route ----------- */}
          <Route
            path={`/${currentClient?.id}/asset/*`}
            element={
              findUserPremission(
                [
                  "Voucher.Asset.FixedAsset.View",
                  "Voucher.Asset.DisposedAsset.View",
                  "Master.AssestsLocation.View",
                ],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Asset],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <SalesInvoiceTemplate
                  element={<AssetsNestedRoute />}
                  silderName={ISilderName.FixedAsset}
                  breadcrumprops={[
                    {
                      item: "Assets",
                      path: `/billing/clients/${currentClient?.id}/asset/fixedAsset`,
                    },
                  ]}
                  menuprops={[
                    {
                      showData: "Fixed Assets",
                      addButton: "fixedasset",
                    },
                    // {
                    //   showData: "Depreciations",
                    //   addButton: "depreciations",
                    // },
                    {
                      showData: "Disposed",
                      addButton: "disposed",
                    },
                    {
                      showData: "Location",
                      addButton: "location",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/asset/addFixedAsset`}
            element={
              findUserPremission(
                ["Voucher.Asset.FixedAsset.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Asset],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AssetModel />}
                  breadcrumprops={[
                    {
                      item: "Assets",
                      path: `/billing/clients/${currentClient?.id}/asset/fixedAsset`,
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Journals Route ----------- */}
          <Route
            path={`${currentClient?.id}/journals`}
            element={
              findUserPremission(
                ["Voucher.Journal.View"],
                clientSpecificRole(),
                currentClient?.id!,
                [SettingsSections.Journal],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<Journals />}
                  breadcrumprops={[
                    {
                      item: "Journals",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/journals/add`}
            element={
              findUserPremission(
                ["Voucher.Journal.Add"],
                clientSpecificRole(),
                currentClient?.id!,
                [SettingsSections.Journal],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddJournalNew />}
                  breadcrumprops={[
                    {
                      item: "Journals",
                      path: `/billing/clients/${currentClient?.id}/journals`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/journals/editDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Journal.Edit"],
                clientSpecificRole(),
                currentClient?.id!,
                [SettingsSections.Journal],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddJournalNew />}
                  breadcrumprops={[
                    {
                      item: "Journals",
                      path: `/billing/clients/${currentClient?.id}/journals`,
                    },
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/journals/:journalId`}
            element={
              findUserPremission(
                ["Voucher.Journal.Edit"],
                clientSpecificRole(),
                currentClient?.id!,
                [SettingsSections.Journal],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddJournalNew />}
                  breadcrumprops={[
                    {
                      item: "Journals",
                      path: `/billing/clients/${currentClient?.id}/journals`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Expenses & Income Route ----------- */}
          <Route
            key="expenses and income"
            path={`/${currentClient?.id}/*`}
            element={
              findUserPremission(
                [
                  "Voucher.Expenses.View",
                  "Voucher.Income.View",

                  "Master.Ledger.Expenses.View",
                  "Master.Ledger.Income.View",

                  "Master.Group.Expenses.View",
                  "Master.Group.Income.View",
                ],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Invoice, SettingsSections.Expenses],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <SalesInvoiceTemplate
                  silderName={ISilderName.Expenses}
                  element={<ExpensesIncomeNestedRoute />}
                  breadcrumprops={[
                    {
                      item: null,
                      path: `/billing/clients/${currentClient?.id}/expenses`,
                    },
                  ]}
                  menuprops={[
                    {
                      showData: "Expenses",
                    },
                    {
                      showData: "Expenses Ledger",
                    },
                    {
                      showData: "Expenses Group",
                    },
                    {
                      showData: "Income",
                    },
                    {
                      showData: "Income Ledger",
                    },
                    {
                      showData: "Income Group",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/expenses/addExpenses`}
            element={
              findUserPremission(
                ["Voucher.Expenses.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Expenses],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddExpensesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Expenses",
                      path: `/billing/clients/${currentClient?.id}/expenses`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/expenses/editExpenses/:updateId`}
            element={
              findUserPremission(
                ["Voucher.Expenses.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Expenses],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddExpensesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Expenses",
                      path: `/billing/clients/${currentClient?.id}/expenses`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/expenses/editExpensesDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Expenses.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Expenses],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddExpensesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Expenses",
                      path: `/billing/clients/${currentClient?.id}/expenses`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/expenses/cloneExpenses/:cloneId`}
            element={
              findUserPremission(
                ["Voucher.Expenses.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Expenses],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddExpensesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Expenses",
                      path: `/billing/clients/${currentClient?.id}/expenses`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/income/addIncome`}
            element={
              findUserPremission(
                ["Voucher.Income.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Income],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddExpensesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Income",
                      path: `/billing/clients/${currentClient?.id}/income`,
                    },
                    {
                      item: "Add",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/income/editIncome/:updateId`}
            element={
              findUserPremission(
                ["Voucher.Income.Edit"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Income],
                {
                  actionType: IPermissionActionType.Edit,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddExpensesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Income",
                      path: `/billing/clients/${currentClient?.id}/income`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/income/editIncomeDraft/:draftId`}
            element={
              findUserPremission(
                ["Voucher.Income.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Income],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddExpensesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Income",
                      path: `/billing/clients/${currentClient?.id}/income`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/income/cloneIncome/:cloneId`}
            element={
              findUserPremission(
                ["Voucher.Income.Add"],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Income],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<AddExpensesInvoice />}
                  breadcrumprops={[
                    {
                      item: "Income",
                      path: `/billing/clients/${currentClient?.id}/income`,
                    },
                    {
                      item: "Edit",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Share capital Route ----------- */}
          <Route
            key="sharecapital"
            path={`/${currentClient?.id}/sharecapital/*`}
            element={
              <SalesInvoiceTemplate
                silderName={ISilderName.ShareCapital}
                element={<ShareCapitalNestedRoute />}
                breadcrumprops={[
                  {
                    item: "Share Capital",
                    path: `/billing/clients/${currentClient?.id}/sharecapital/sharecapital`,
                  },
                ]}
                menuprops={[
                  {
                    showData: "Share Capital",
                  },
                  {
                    showData: "Shareholders",
                  },

                  {
                    showData: "Dividents",
                  },
                ]}
              />
            }
          />

          {/*  ----------- Cash & Bank Route -----------  */}
          <Route
            path={`/${currentClient?.id}/banking/*`}
            element={
              findUserPremission(
                [
                  "Voucher.Contra.View",
                  "Master.Ledger.Bank.View",
                  "Master.Ledger.Cash.View",
                  "Master.BankReconciliation.View",
                  "Master.LoanAccount.View",
                  "Master.Cheque.View",
                ],
                clientSpecificRole(),
                currentClient?.id,
                [SettingsSections.Contra],
                {
                  actionType: IPermissionActionType.Add,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <SalesInvoiceTemplate
                  silderName={ISilderName.Banking}
                  element={<BankingNestedRoute />}
                  breadcrumprops={[
                    {
                      item: "Banking",
                      path: `/billing/clients/${currentClient?.id}/banking/bankAccount`,
                    },
                  ]}
                  menuprops={[
                    { showData: "Bank Accounts", addButton: "banking/Banks" },
                    { showData: "Cash In Hand", addButton: "cashInHand" },
                    // { showData: "Cheque", addButton: "cheque" },
                    // { showData: "Loan Accounts", addButton: "loanAccounts" },
                    {
                      showData: "Bank Reconciliation",
                      addButton: "bank Reconciliation",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Ledger Route ----------- */}
          {/* <Route
            path={`/${currentClient?.id}/registers/*`}
            element={
              <DashboardTemplate
                element={<Re />}
                breadcrumprops={[
                  {
                    item: "Registers",
                  },
                ]}
              />
            }
          /> */}
          {/* ----------- Ageing Route ----------- */}
          {
            <Route
              path={`/${currentClient?.id}/registers/*`}
              element={
                findUserPremission(
                  [
                    "Voucher.Sales.Invoice.View",
                    "Voucher.Sales.ProformaInvoice.View",
                    "Voucher.Sales.CreditNote.View",
                    "Voucher.Sales.Receipt.View",
                    "Voucher.Sales.Estimate.View",
                    "Voucher.Sales.SalesOrder.View",

                    "Voucher.Purchase.Bill.View",
                    "Voucher.Purchase.DebitNote.View",
                    "Voucher.Purchase.PaymentOut.View",
                    "Voucher.Purchase.PurchaseOrder.View",

                    "Voucher.Expenses.View",
                    "Voucher.Income.View",

                    "Voucher.Journal.View",

                    "Voucher.Contra.View",

                    "Voucher.Asset.FixedAsset.View",
                  ],
                  clientSpecificRole(),
                  currentClient?.id!,
                  [
                    SettingsSections.Invoice,
                    SettingsSections.PInvoice,
                    SettingsSections.CrNote,
                    SettingsSections.Receipt,
                    SettingsSections.Quotation,
                    SettingsSections.SOrder,

                    // Purchase
                    SettingsSections.PurInvoice,
                    SettingsSections.DrNote,
                    SettingsSections.Payment,
                    SettingsSections.POrder,

                    // expenses & income
                    SettingsSections.Expenses,
                    SettingsSections.Income,

                    // Journal
                    SettingsSections.Journal,
                    // Contra
                    SettingsSections.Contra,
                    // Asset
                    SettingsSections.Asset,
                  ],
                  {
                    actionType: IPermissionActionType.View,
                    dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                  }
                ) ? (
                  <DashboardTemplate
                    element={<Registers />}
                    breadcrumprops={[
                      {
                        item: "Registers",
                      },
                    ]}
                  />
                ) : (
                  <ResourceNotFound pageHeight="100%" />
                )
              }
            />
          }
          {/* defaultActiveKey={"1"} */}
          {
            <Route
              path={`/${currentClient?.id}/banking/bankTransactionsDetails`}
              element={
                <DashboardTemplate
                  element={<BankTransactionsTab />}
                  breadcrumprops={[
                    {
                      item: "Banking",
                      path: `/billing/clients/${currentClient?.id}/banking/bankAccounts`,
                    },
                    {
                      item: "BankTransactionsDetails",
                    },
                  ]}
                />
              }
            />
          }
          {
            <Route
              path={`/${currentClient?.id}/banking/bankTransactionsHistory`}
              element={
                <DashboardTemplate
                  element={<BankTransactionsTab />}
                  breadcrumprops={[
                    {
                      item: "Banking",
                      path: `/billing/clients/${currentClient?.id}/banking/bankAccounts`,
                    },
                    {
                      item: "BankTransactionsHistory",
                    },
                  ]}
                />
              }
            />
          }
          {
            <Route
              path={`/${currentClient?.id}/banking/bankTransactionsDetails/:id`}
              element={
                <DashboardTemplate
                  element={<BankTransactionsTab />}
                  breadcrumprops={[
                    {
                      item: "Banking",
                      path: `/billing/clients/${currentClient?.id}/banking/bankAccounts`,
                    },
                    {
                      item: "BankTransactionsDetails",
                    },
                  ]}
                />
              }
            />
          }
          {/* {
            <Route
              path={`/${currentClient?.id}/banking/bankAccount/bankTransactionsDetails/getBankImportData*`}
              element={
                <DashboardTemplate
                  element={<GetBankImportData />}
                  breadcrumprops={[
                    {
                      item: "GetBankImportData",
                    },
                  ]}
                />
              }
            />
          } */}
          {
            <Route
              path={`/${currentClient?.id}/reports/generalLedger/*`}
              element={
                findUserOnlyOnePremission(
                  "Report.GeneralLedger.View",
                  clientSpecificRole(),
                  currentClient?.id!
                ) ? (
                  <DashboardTemplate
                    element={<GeneralLedger />}
                    breadcrumprops={[
                      {
                        item: "Reports",
                        path: `/billing/clients/${currentClient?.id}/reports`,
                      },
                      {
                        item: "General ledger",
                      },
                    ]}
                  />
                ) : (
                  <ResourceNotFound pageHeight="100%" />
                )
              }
            />
          }
          {/* <Route
            path={`/${currentClient?.id}reports/ageing/*`}
            element={
               findUserReportAccessSecurity(
                useAccessSettingsData,
                Report_Type.PnL,
                Report_TypeAction.allowToView
              ) ?
              <DashboardTemplate
                element={<Ageing />}
                breadcrumprops={[
                  {
                    item: "Ageing Report",
                  },
                ]}
              /> : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          /> */}
          {/* ----------- Trial Balance Route ----------- */}
          <Route
            path={`/${currentClient?.id}/trialbalance/*`}
            element={
              findUserOnlyOnePremission(
                "Report.TrialBalance.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<TrialBalance />}
                  breadcrumprops={[
                    {
                      item: "Trial Balance",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ---------- Trial Balance Route_new --------- */}
          <Route
            path={`/${currentClient?.id}/reports/trialbalancenew/*`}
            element={
              findUserOnlyOnePremission(
                "Report.TrialBalance.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<TrialBalanceNew />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Trial Balance",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`/${currentClient?.id}/reports/far/*`}
            element={
              findUserOnlyOnePremission(
                "Report.FixedAssets.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<FAR />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Fixed Assets Register",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`/${currentClient?.id}/reports/brsReports/*`}
            element={
              findUserOnlyOnePremission(
                "Report.BankReconciliation.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<BRSReport />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Bank Reconciliation",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Profit & Loss Route -----------
          <Route
            path={`/${currentClient?.id}/profitAndLoss/*`}
            element={
              <DashboardTemplate
                element={<ProfitAndLoss />}
                breadcrumprops={[
                  {
                    item: "Profit And Loss",
                  },
                ]}
              />
            }
          /> */}
          {/* ----------- Profit & Loss Route ----------- */}
          <Route
            path={`/${currentClient?.id}/reports/profitAndLoss/*`}
            element={
              findUserOnlyOnePremission(
                "Report.P&L.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<ProfitAndLossNew type={Statements.ProfitAndLoss} />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Profit And Loss",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Balance Sheet Route ----------- */}
          <Route
            path={`/${currentClient?.id}/reports/balanceSheet/*`}
            element={
              findUserOnlyOnePremission(
                "Report.BalanceSheet.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<ProfitAndLossNew type={Statements.BalanceSheet} />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Balance Sheet",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`/${currentClient?.id}/reports/GSTReports/*`}
            element={
              findUserOnlyOnePremission(
                "Report.GST.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<GSTReports />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "GST Report",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`/${currentClient?.id}/Reports/*`}
            element={
              findUserPremission(
                [
                  "Report.BalanceSheet.View",
                  "Report.P&L.View",
                  "Report.TrialBalance.View",
                  "Report.CashFlow.View",
                  "Report.DebtorsAgeing.View",
                  "Report.CreditorsAgeing.View",
                  "Report.CustomerOutstanding.View",
                  "Report.SupplierOutstanding.View",
                  "Report.GeneralLedger.View",
                  "Report.FixedAssets.View",
                  "Report.BankReconciliation.View",
                  "Report.GST.View",
                  "Report.Tds.View",
                  "Report.Tcs.View",
                ],
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<Reports />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            key="ageing"
            path={`/${currentClient?.id}/reports/ageing/debtors`}
            element={
              findUserOnlyOnePremission(
                "Report.DebtorsAgeing.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<Ageing SelType={AgeingReportTypes.Debtors} />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Ageing Report",
                      path: `/billing/clients/${currentClient?.id}/reports/ageing/debtors`,
                    },
                    {
                      item: "Debtors",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            key="ageing"
            path={`/${currentClient?.id}/reports/ageing/creditors`}
            element={
              findUserOnlyOnePremission(
                "Report.CreditorsAgeing.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<Ageing SelType={AgeingReportTypes.Creditors} />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Ageing Report",
                      path: `/billing/clients/${currentClient?.id}/reports/ageing/creditors`,
                    },
                    {
                      item: "Creditors",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            key="ageing"
            path={`/${currentClient?.id}/reports/partyOutstanding/customer`}
            element={
              findUserOnlyOnePremission(
                "Report.CustomerOutstanding.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<PartyOutstanding Type={0} />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Customer Outstanding",
                      // path: `/billing/clients/${currentClient?.id}/reports/partyOutstanding/customer`,
                    },
                    // {
                    //   item: "Customer Outstanding",
                    // },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            key="ageing"
            path={`/${currentClient?.id}/reports/partyOutstanding/supplier`}
            element={
              findUserOnlyOnePremission(
                "Report.SupplierOutstanding.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<PartyOutstanding Type={1} />}
                  breadcrumprops={[
                    {
                      item: "Reports",
                      path: `/billing/clients/${currentClient?.id}/reports`,
                    },
                    {
                      item: "Supplier Outstanding",
                      // path: `/billing/clients/${currentClient?.id}/reports/partyOutstanding/supplier`,
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Bank Route ----------- */}
          {/* <Route
            path={`/${currentClient?.id}/baking/banks/*`}
            element={
              <DashboardTemplate
                element={<Banking />}
                breadcrumprops={[
                  {
                    item: "Banks",
                  },
                ]}
              />
            }
          /> */}
          {/* ----------- Opening Balance Route ----------- */}
          {/* <Route
            path={`/${currentClient?.id}/openingBalance/*`}
            element={
              <DashboardTemplate
                element={<OpeningBalance />}
                breadcrumprops={[
                  {
                    item: "Opening Balance",
                  },
                ]}
              />
            }
          /> */}
          {/* ----------- Chart Of Accounts Route ----------- */}
          {/* <Route
            path={`/${currentClient?.id}/chartOfAccounts/*`}
            element={
              <DashboardTemplate
                element={<ChartOfAccounts />}
                breadcrumprops={[
                  {
                    item: "Chart Of Accounts",
                  },
                ]}
              />
            }
          /> */}
          {/* ----------- Settings Route ----------- */}
          <Route
            path={`/${currentClient?.id}/settings/*`}
            element={
              findUserPremission(
                [
                  "Setting.Company.Info.View",
                  "Setting.Company.Details.View",
                  "Setting.Company.PaymentTerm.View",
                  "Setting.Company.GST.View",

                  "Setting.Voucher.Sales.View",
                  "Setting.Voucher.ProformaInvoice.View",
                  "Setting.Voucher.CreditNote.View",
                  "Setting.Voucher.Receipt.View",
                  "Setting.Voucher.Estimate.View",
                  "Setting.Voucher.SalesOrder.View",

                  "Setting.Voucher.Bill.View",
                  "Setting.Voucher.DebitNote.View",
                  "Setting.Voucher.PaymentOut.View",
                  "Setting.Voucher.PurchaseOrder.View",

                  "Setting.Voucher.Expenses.View",
                  "Setting.Voucher.Income.View",

                  "Setting.Voucher.Contra.View",
                  "Setting.Voucher.Journal.View",
                  "Setting.Voucher.FixedAsset.View",

                  "Setting.Item.View",
                  "Setting.OpeningBalance.View",
                  "Setting.Templates.View",
                  "Setting.DefaultLedger.View",

                  "Setting.TC.Sales.View",
                  "Setting.TC.ProformaInvoice.View",
                  "Setting.TC.CreditNote.View",
                  "Setting.TC.Receipt.View",
                  "Setting.TC.Estimate.View",
                  "Setting.TC.SalesOrder.View",
                  "Setting.TC.Bill.View",
                  "Setting.TC.DebitNote.View",
                  "Setting.TC.PaymentOut.View",
                  "Setting.TC.PurchaseOrder.View",
                  "Setting.TC.Expenses.View",
                  "Setting.TC.Income.View",
                  "Setting.TC.Contra.View",
                  "Setting.TC.Journal.View",
                  "Setting.TC.FixedAsset.View",

                  "Setting.TDS.View",
                  "Setting.TCS.View",

                  "Setting.Currencies.View",
                ],
                clientSpecificRole(),
                currentClient?.id!,
                [
                  SettingsSections.Invoice,
                  SettingsSections.PInvoice,
                  SettingsSections.CrNote,
                  SettingsSections.Receipt,
                  SettingsSections.Quotation,
                  SettingsSections.SOrder,

                  // Purchase
                  SettingsSections.PurInvoice,
                  SettingsSections.DrNote,
                  SettingsSections.Payment,
                  SettingsSections.POrder,

                  // expenses & income
                  SettingsSections.Expenses,
                  SettingsSections.Income,

                  // Journal
                  SettingsSections.Journal,
                  // Contra
                  SettingsSections.Contra,
                  // Asset
                  SettingsSections.Asset,
                ],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [
                    ITypeIIsClientSpecificRoleDataType.Setting,
                    ITypeIIsClientSpecificRoleDataType.TandC,
                  ],
                }
              ) ? (
                <SalesInvoiceTemplate
                  silderName={ISilderName.Settings}
                  element={<SettingNestedRoute />}
                  breadcrumprops={[
                    {
                      item: "Company Settings",
                      path: `/billing/clients/${currentClient?.id}/settings/companyInfo`,
                    },
                  ]}
                  menuprops={[
                    { showData: "Company Info" },
                    { showData: "Vouchers" },
                    { showData: "Items" },
                    // { showData: "Payment Term" },
                    // { showData: "GST" },
                    // { showData: "Report" },
                    { showData: "Opening Balance" },
                    // { showData: "Email" },
                    { showData: "Templates" },
                    // { showData: "AdvSetting" },
                    { showData: "Default Ledger" },
                    { showData: "Terms And Conditions" },
                    { showData: "TDS" },
                    { showData: "Currencies" },
                    { showData: "Lock Month" },
                    // { showData: "NewDashboard" },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* ----------- Templetes Route ----------- */}
          {/* <Route
            path={`${currentClient?.id}/settings/templates/1`}
            element={
              <DashboardTemplate
                element={<EditTemplate />}
                breadcrumprops={[
                  {
                    item: "Company Settings",
                    path: `/billing/clients/${currentClient?.id}/settings/companyInfo`,
                  },
                  {
                    item: "Templates",
                    path: `/billing/clients/${currentClient?.id}/settings/templates`,
                  },
                  {
                    item: "1",
                  },
                ]}
              />
            }
          /> */}
          <Route
            path={`${currentClient?.id}/settings/templates/:type`}
            element={
              findUserOnlyOnePremission(
                "Setting.Templates.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<EditInvoiceTemplate />}
                  breadcrumprops={[
                    {
                      item: "Company Settings",
                      path: `/billing/clients/${currentClient?.id}/settings/companyInfo`,
                    },
                    {
                      item: "Templates",
                      path: `/billing/clients/${currentClient?.id}/settings/templates`,
                    },
                    // {
                    //   item: `/:type`,
                    // },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          {/* <Route
            path={`${currentClient?.id}/settings/templates/2`}
            element={
              <DashboardTemplate
                element={<EditInvoiceTemplate />}
                breadcrumprops={[
                  {
                    item: "Company Settings",
                    path: `/billing/clients/${currentClient?.id}/settings/companyInfo`,
                  },
                ]}
              />
            }
          /> */}
          {/* Inventory Route */}
          {/* <Route
            path={`${currentClient?.id}/master/items/inventory`}
            element={
              <DashboardTemplate
                element={<InventoryTabs />}
                breadcrumprops={[
                  {
                    item: "Master",
                    path: `/billing/clients/${currentClient?.id}/master/ledger`,
                  },
                  {
                    item: "Items",
                    path: `/billing/clients/${currentClient?.id}/master/items`,
                  },
                  {
                    item: "Goods",
                  },
                ]}
              />
            }
          /> */}
          <Route
            path={`${currentClient?.id}/item/items/inventory`}
            element={
              findUserPremission(
                ["Master.Item.View"],
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <DashboardTemplate
                  element={<InventoryTabs />}
                  breadcrumprops={[
                    {
                      item: "Item",
                      path: `/billing/clients/${currentClient?.id}/item/items`,
                    },

                    {
                      item: "Items",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/draft/*`}
            element={
              findUserPremission(
                [
                  "Voucher.Sales.Invoice.View",
                  "Voucher.Sales.ProformaInvoice.View",
                  "Voucher.Sales.CreditNote.View",
                  "Voucher.Sales.Receipt.View",
                  "Voucher.Sales.Estimate.View",
                  "Voucher.Sales.SalesOrder.View",

                  "Voucher.Purchase.Bill.View",
                  "Voucher.Purchase.DebitNote.View",
                  "Voucher.Purchase.PaymentOut.View",
                  "Voucher.Purchase.PurchaseOrder.View",

                  "Voucher.Expenses.View",
                  "Voucher.Income.View",

                  "Voucher.Journal.View",

                  "Voucher.Contra.View",

                  "Voucher.Asset.FixedAsset.View",
                ],
                clientSpecificRole(),
                currentClient?.id,
                [
                  SettingsSections.Invoice,
                  SettingsSections.PInvoice,
                  SettingsSections.CrNote,
                  SettingsSections.Receipt,
                  SettingsSections.Quotation,
                  SettingsSections.SOrder,

                  // Purchase
                  SettingsSections.PurInvoice,
                  SettingsSections.DrNote,
                  SettingsSections.Payment,
                  SettingsSections.POrder,

                  // expenses & income
                  SettingsSections.Expenses,
                  SettingsSections.Income,

                  // Journal
                  SettingsSections.Journal,
                  // Contra
                  SettingsSections.Contra,
                  // Asset
                  SettingsSections.Asset,
                ],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                <DashboardTemplate
                  element={<DraftTable />}
                  breadcrumprops={[
                    {
                      item: "Draft",
                    },
                  ]}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path={`${currentClient?.id}/*`}
            element={<ResourceNotFound pageHeight="100%" />}
          />
          {/* Roles Route */}
          <Route
            path={`${currentClient?.id}/roles`}
            element={
              // findUserPremission(
              //   ["Master.Item.View"],
              //   clientSpecificRole(),
              //   currentClient?.id!
              // ) ? (
              <DashboardTemplate
                element={<RoleTable clientId={currentClient?.id!} />}
                breadcrumprops={[
                  {
                    item: "Item",
                    path: `/billing/clients/${currentClient?.id}/item/items`,
                  },

                  {
                    item: "Items",
                  },
                ]}
              />
              // ) : (
              //   <ResourceNotFound pageHeight="100%" />
              // )
            }
          />
          {/* Organisations Route */}
          <Route
            key="organisations"
            path={`${currentClient?.id}/organisations/*`}
            element={
              <SalesInvoiceTemplate
                element={<OrganisationNestedRoute />}
                silderName={ISilderName.Organisations}
                breadcrumprops={[
                  {
                    item: "Organisations",
                    path: `/billing/clients/${currentClient?.id}/organisations/organisations`,
                  },
                ]}
                menuprops={[
                  {
                    showData: "Organisations",
                  },
                  {
                    showData: "Sub Units",
                  },
                  {
                    showData: "Departments",
                  },
                  {
                    showData: "Designations",
                  },
                  {
                    showData: "Employees",
                  },
                ]}
              />
            }
          />
        </Routes>
        {/* <Route
          path={`${currentClient?.id}/users/add`}
          element={
            <DashboardTemplate
              element={<AddCustomer />}
              breadcrumprops={[
                {
                  item: "Users",
                  path: `/billing/clients/${currentClient?.id}/Users`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          }
        /> */}
        {/* </React.Suspense> */}
        {contextHolder}
      </>
    </notificationContext.Provider>
  );
};
export default PageRoute;
